import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {I18n} from 'react-redux-i18n';

import {LABEL_GET_PDF} from '../../common/apiEndpoints';

const LabelPageButtons = ({
	onClear,
	pdfId
}) => {
	const pdfLink = `${LABEL_GET_PDF}/${pdfId}`;
	return (
		<div className="col-xl-12 col-sm-4 text-right">
      <button type="button" className="btn btn-secondary" onClick={onClear}>{I18n.t('CLEAR')}</button>
      <Link to={pdfLink} target="_blank" className="btn btn-primary">{I18n.t('GENERATE')}</Link> 
    </div>
	);
};

LabelPageButtons.propTypes = {
	onClear: PropTypes.func.isRequired,
	pdfId: PropTypes.string.isRequired
};

export default LabelPageButtons;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/LabelPageButtons.js
 **/